import { Box, Typography } from '@mui/material'
import React from 'react'
import { SectionTitle } from '../../../components'

const CareerJoin = () => {
  return (
    <Box
        sx={{
            paddingBottom:'5rem'
        }}
    >
        <SectionTitle 
            firstTitleWord='is not a job'
            secondTitleWord='is a career'
            textStyle={{
                textTransform:'uppercase',
                fontWeight:'1000',
                '@media screen and (max-width:762px)':{
                    fontWeight:'500',
                }
            }}
            sx={{
                '@media screen and (max-width: 762px)':{
                    paddingY: '2rem'
                }    
            }}
        />

        <Box
            sx={{
                width:'70%',
                padding:'2rem',
                '@media screen and (max-width: 762px)':{
                    padding:'0 2rem'
                }
            }}
        >
            <Typography
                variant='h1'
                sx={{
                    fontFamily:'var(--title-font)',
                    fontSize:'2rem',
                    textTransform:'capitalize',
                    color:'var(--color-secondary)',
                    fontWeight:'500',
                    paddingBottom:'2rem'
                }}
            >Join our team</Typography>

            <Typography
                variant='body'
                sx={{
                    fontFamily:'var(--text-font)',
                    fontSize:'1.2rem'
                }}
            >
                At Pangu Enterprises, we believe that our people are the foundation of our success. We're always looking for passionate, skilledm and driven individuals to join our growing team. <br /> <br/>
                
                Whether you're a seasoned professional or just starting your career, we offer a dynamic work environment, opportunities for growth, and the chance to be part of innovative and impactful projects across Residential, Commercial, Institutional Construction, and more.
            </Typography>
        </Box>
    </Box>
  )
}

export default CareerJoin